import { GroupContract, InventoryStatistics, Product } from '../../roominglist/dtt/getEventSummaryById.types';
import { PropertyResponse } from '../addHotel.types';

export type AddHotelDttInput = {
  propertyId: string;
  imageLimitPerCategory: number;
  input?: GroupEventsAtPropertyInput;
  limit: number;
};

export type GroupEventsAtPropertyInput = {
  propertyId: string;
  filters: {
    groupCode: string;
  };
  activeStatus: ActiveStatus;
  groupBlockCodeExactMatch: boolean;
  eventLookupDateRange: {
    startDate: string;
    endDate?: string;
  };
};

export type AddHotelDttResponse = {
  property: PropertyResponse;
  hotelOperations?: {
    groupManagement: {
      groupsMultipleGroupEventsAtProperty: {
        groupBlocks: {
          sourceCRS: SourceCRS;
          groupContract: GroupContract;
          inventoryStatistics: InventoryStatistics;
          products: Product[];
        }[];
      };
    };
  };
};

export enum SourceCRS {
  MARSHA = 'MARSHA',
  ACRS = 'ACRS',
  DSP = 'DSP',
}

export enum ActiveStatus {
  ACTIVE = 'ACTIVE',
  CANCELLED = 'CANCELLED',
}
